import { render, staticRenderFns } from "./DesignOppositionBasisForOppositionList.vue?vue&type=template&id=2d78f1ff&"
import script from "./DesignOppositionBasisForOppositionList.vue?vue&type=script&lang=js&"
export * from "./DesignOppositionBasisForOppositionList.vue?vue&type=script&lang=js&"
import style0 from "./DesignOppositionBasisForOppositionList.vue?vue&type=style&index=0&id=2d78f1ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports